import { IonIcon } from '@ionic/react'
import { trophyOutline } from 'ionicons/icons'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Level } from '../types/level'
import { levelStyles } from '../utils/styles/levelStyles'

interface LevelBadgeProps {
	level: Level
	isLoading: boolean
}

const LevelBadge: FC<LevelBadgeProps> = ({ level }) => {
	const { t } = useTranslation('pages_saving')
	const { style, iconColor, textColor } = levelStyles[level]

	return (
		<div
			className={`flex flex-row items-center gap-2 w-fit h-fit px-8 py-1 rounded-full border ${style}`}
		>
			<IonIcon icon={trophyOutline} className={`${iconColor} [--ionicon-stroke-width:48px]`} />
			<span className={textColor}>{t(level)}</span>
		</div>
	)
}

export default LevelBadge
